const T = {
  en: {
    nav: { home: "Home", catalog: "Catalog", routes: "Routes", contact: "Contact", admin: "Admin" },
    hero: {
      title: "Sports & luxury cars.",
      subtitle: "Premium car rental experiences in Costa Blanca.",
      cta: "Explore Collection",
    },
    catalog: {
      kicker: "The Collection",
      title: "Choose Your Experience",
      subtitle: "Luxury and sports cars ready for your next drive.",
      filterAll: "All",
      viewImages: "View Images",
      conditions: "Conditions",
      moreInfo: "More information",
      reserve: "Reserve on WhatsApp",
      contactWa24h: "Contact via WhatsApp 24H",
      selectDates: "Select pickup and return dates",
      pricePerDay: "per day",
      from: "From",
      available: "Available",
      notAvailable: "Not available",
      empty: "No vehicles in this category yet.",
      perMonth: "/ month",
      priceOnRequest: "Price on request",
      hp: "HP",
      topSpeed: "Top",
      acceleration: "0-100",
      seats: "seats",
      location: "Location",
    },
    vehicleDetail: {
      notFound: "This vehicle is not available right now.",
      backToCatalog: "Back to the collection",
      reserveWithDates: "Reserve with dates",
      contactDirect: "Direct contact",
      faqTitle: "Frequently asked questions",
      deposit: "Deposit",
      extraKm: "Extra km",
    },
    booking: {
      title: "Reserve this car",
      pickupDate: "Pickup date",
      returnDate: "Return date",
      numberOfDays: "Number of days",
      pickupLocation: "Pickup location",
      returnLocation: "Return location",
      selectDatesOrDays: "Select dates or number of days",
      estimatedTotal: "Estimated total",
      invalidDates: "Invalid dates",
      minimumRental: "Minimum rental: 1 day",
      days: "days",
      day: "day",
      reserve: "Reserve on WhatsApp",
      pickDate: "Pick a date",
      perDay: "/ day",
      perWeek: "/ week",
      perMonth: "/ month",
      locationPlaceholder: "Hotel, airport, address or city",
    },
    locations: ["Alicante Airport", "Benidorm", "Altea", "Calpe", "Moraira", "Jávea", "Dénia", "Valencia Airport"],
    conditions: {
      title: "Rental Conditions",
      vehicleConditions: "Vehicle conditions",
      globalConditions: "General conditions",
      close: "Close",
    },
    routes: {
      kicker: "Driving Routes",
      title: "Luxury Driving Routes",
      subtitle: "Discover Costa Blanca through curated premium routes.",
      explore: "Explore Route",
      recommendedCar: "Recommended car",
      stops: "Main stops",
      book: "Book this route",
      backToRoutes: "Back to routes",
      gallery: "Gallery",
      seoText: "Designed for drivers who want more than a road. Reserve your car via WhatsApp and let us prepare the experience.",
      whyPremium: "Why this route is perfect for a luxury or sports car",
      bestTime: "Best time of day",
      duration: "Approximate duration",
    },
    guides: { title: "Guides" },
    contact: {
      kicker: "Get in touch",
      title: "Ready to drive?",
      subtitle: "Send us your dates and we will confirm availability directly by WhatsApp.",
      cta: "Contact via WhatsApp",
      hours: "Opening hours",
      location: "Address",
      email: "Email",
      phone: "Phone",
      reservations: "Reservations (WhatsApp)",
    },
    footer: {
      tagline: "Premium driving experiences on the Mediterranean coast.",
      rights: "All rights reserved.",
      legal: "Legal",
      brand: "Brand",
      contactUs: "Contact",
      guides: "Featured cars",
      guidesLink: "Guides",
    },
    legal: {
      kicker: "Legal", pendingReview: "Pending legal review",
      rental_conditions: "Rental Conditions",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      cookies: "Cookies Policy",
    },
    whatsapp: {
      simple: (v) => `Hello, I would like information about this vehicle: ${v}`,
      simpleDates: (v, p, r) =>
        `Hello, I would like information about this vehicle:\n\nVehicle: ${v}\nPickup date: ${p}\nReturn date: ${r}\n\nThank you.`,
      // Kept for backwards compatibility with any caller that still imports
      // `withDates` — now resolves to the simpler date-only message.
      withDates: (v, p, r) =>
        `Hello, I would like information about this vehicle:\n\nVehicle: ${v}\nPickup date: ${p}\nReturn date: ${r}\n\nThank you.`,
      generic: "Hello, I would like information about your luxury rental fleet.",
      routeInquiry: (route) => `Hello, I am interested in the route: ${route}. Could you recommend a car and confirm availability?`,
    },
    admin: {
      login: "Admin Login",
      email: "Email",
      password: "Password",
      currentPassword: "Current password",
      newPassword: "New password",
      changePassword: "Change password",
      signin: "Sign in",
      dashboard: "Dashboard",
      vehicles: "Vehicles",
      adminRoutes: "Routes",
      bookings: "Bookings",
      settings: "Settings",
      logout: "Logout",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      confirm: "Are you sure?",
      noData: "No data yet.",
      uploadImage: "Upload image",
      uploadVideo: "Upload video",
      uploadFile: "Upload file",
      dropHere: "Drop or click to upload",
      mainPhoto: "Main",
      makeMain: "Make main",
      moveUp: "Move up",
      moveDown: "Move down",
      missingData: "Missing data",
    },
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    dateFormat: "dd/MM/yyyy",
  },
  es: {
    nav: { home: "Inicio", catalog: "Catálogo", routes: "Rutas", contact: "Contacto", admin: "Admin" },
    hero: {
      title: "Coches deportivos y de lujo.",
      subtitle: "Experiencias premium de alquiler en Costa Blanca.",
      cta: "Ver colección",
    },
    catalog: {
      kicker: "La Colección",
      title: "Elige tu experiencia",
      subtitle: "Coches deportivos y de lujo listos para tu próxima ruta.",
      filterAll: "Todos",
      viewImages: "Ver imágenes",
      conditions: "Condiciones",
      moreInfo: "Más información",
      reserve: "Reservar por WhatsApp",
      contactWa24h: "Contacta por WhatsApp 24H",
      selectDates: "Selecciona fechas de recogida y devolución",
      pricePerDay: "por día",
      from: "Desde",
      available: "Disponible",
      notAvailable: "No disponible",
      empty: "Aún no hay vehículos en esta categoría.",
      perMonth: "/ mes",
      priceOnRequest: "Precio bajo consulta",
      hp: "CV",
      topSpeed: "Máx",
      acceleration: "0-100",
      seats: "plazas",
      location: "Ubicación",
    },
    vehicleDetail: {
      notFound: "Este vehículo no está disponible en este momento.",
      backToCatalog: "Volver a la colección",
      reserveWithDates: "Reservar con fechas",
      contactDirect: "Contacto directo",
      faqTitle: "Preguntas frecuentes",
      deposit: "Fianza",
      extraKm: "Km adicional",
    },
    booking: {
      title: "Reservar este coche",
      pickupDate: "Fecha de recogida",
      returnDate: "Fecha de devolución",
      numberOfDays: "Número de días",
      pickupLocation: "Lugar de recogida",
      returnLocation: "Lugar de devolución",
      selectDatesOrDays: "Selecciona fechas o número de días",
      estimatedTotal: "Precio estimado",
      invalidDates: "Fechas no válidas",
      minimumRental: "Alquiler mínimo: 1 día",
      days: "días",
      day: "día",
      reserve: "Reservar por WhatsApp",
      pickDate: "Elige fecha",
      perDay: "/ día",
      perWeek: "/ semana",
      perMonth: "/ mes",
      locationPlaceholder: "Hotel, aeropuerto, dirección o ciudad",
    },
    locations: ["Aeropuerto Alicante", "Benidorm", "Altea", "Calpe", "Moraira", "Jávea", "Dénia", "Aeropuerto Valencia"],
    conditions: {
      title: "Condiciones de alquiler",
      vehicleConditions: "Condiciones del vehículo",
      globalConditions: "Condiciones generales",
      close: "Cerrar",
    },
    routes: {
      kicker: "Rutas de Conducción",
      title: "Rutas de conducción premium",
      subtitle: "Descubre Costa Blanca a través de rutas exclusivas.",
      explore: "Explorar ruta",
      recommendedCar: "Coche recomendado",
      stops: "Paradas principales",
      book: "Reservar esta ruta",
      backToRoutes: "Volver a rutas",
      gallery: "Galería",
      seoText: "Pensadas para conductores que buscan algo más que una carretera. Reserva tu coche por WhatsApp y nosotros preparamos la experiencia.",
      whyPremium: "Por qué esta ruta es perfecta para un coche de lujo o deportivo",
      bestTime: "Mejor momento del día",
      duration: "Duración aproximada",
    },
    guides: { title: "Guías" },
    contact: {
      kicker: "Contacta",
      title: "¿Listo para conducir?",
      subtitle: "Envíanos tus fechas y confirmaremos disponibilidad directamente por WhatsApp.",
      cta: "Contactar por WhatsApp",
      hours: "Horario",
      location: "Dirección",
      email: "Email",
      phone: "Teléfono",
      reservations: "Reservas (WhatsApp)",
    },
    footer: {
      tagline: "Experiencias premium de conducción en la costa mediterránea.",
      rights: "Todos los derechos reservados.",
      legal: "Legal",
      brand: "Marca",
      contactUs: "Contacto",
      guides: "Coches destacados",
      guidesLink: "Guías",
    },
    legal: {
      kicker: "Legal", pendingReview: "Pendiente de revisión legal",
      rental_conditions: "Condiciones de alquiler",
      terms: "Términos y condiciones",
      privacy: "Política de privacidad",
      cookies: "Política de cookies",
    },
    whatsapp: {
      simple: (v) => `Hola, quiero información sobre el vehículo: ${v}`,
      simpleDates: (v, p, r) =>
        `Hola, quiero información sobre este vehículo:\n\nVehículo: ${v}\nFecha de recogida: ${p}\nFecha de devolución: ${r}\n\nGracias.`,
      withDates: (v, p, r) =>
        `Hola, quiero información sobre este vehículo:\n\nVehículo: ${v}\nFecha de recogida: ${p}\nFecha de devolución: ${r}\n\nGracias.`,
      generic: "Hola, quiero información sobre vuestra flota de alquiler de lujo.",
      routeInquiry: (route) => `Hola, me interesa la ruta: ${route}. ¿Podéis recomendarme un coche y confirmar disponibilidad?`,
    },
    admin: {
      login: "Acceso Admin",
      email: "Email",
      password: "Contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Contraseña nueva",
      changePassword: "Cambiar contraseña",
      signin: "Entrar",
      dashboard: "Dashboard",
      vehicles: "Vehículos",
      adminRoutes: "Rutas",
      bookings: "Reservas",
      settings: "Configuración",
      logout: "Salir",
      add: "Añadir",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "¿Seguro?",
      noData: "Aún no hay datos.",
      uploadImage: "Subir imagen",
      uploadVideo: "Subir vídeo",
      uploadFile: "Subir archivo",
      dropHere: "Arrastra o pulsa para subir",
      mainPhoto: "Principal",
      makeMain: "Marcar principal",
      moveUp: "Subir",
      moveDown: "Bajar",
      missingData: "Faltan datos",
    },
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    weekdays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    dateFormat: "dd/MM/yyyy",
  },
  ru: {
    nav: { home: "Главная", catalog: "Каталог", routes: "Маршруты", contact: "Контакт", admin: "Админ" },
    hero: {
      title: "Спортивные и премиальные автомобили.",
      subtitle: "Премиальный прокат автомобилей на Коста-Бланке.",
      cta: "Смотреть коллекцию",
    },
    catalog: {
      kicker: "Коллекция",
      title: "Выберите свой автомобиль",
      subtitle: "Спортивные и премиальные автомобили для вашей поездки.",
      filterAll: "Все",
      viewImages: "Смотреть фото",
      conditions: "Условия",
      moreInfo: "Подробнее",
      reserve: "Забронировать через WhatsApp",
      contactWa24h: "Связаться через WhatsApp 24ч",
      selectDates: "Выберите даты получения и возврата",
      pricePerDay: "за день",
      from: "От",
      available: "Доступно",
      notAvailable: "Недоступно",
      empty: "В этой категории пока нет автомобилей.",
      perMonth: "/ месяц",
      priceOnRequest: "Цена по запросу",
      hp: "л.с.",
      topSpeed: "Макс",
      acceleration: "0-100",
      seats: "мест",
      location: "Расположение",
    },
    vehicleDetail: {
      notFound: "Этот автомобиль сейчас недоступен.",
      backToCatalog: "Вернуться в каталог",
      reserveWithDates: "Бронировать с датами",
      contactDirect: "Прямой контакт",
      faqTitle: "Часто задаваемые вопросы",
      deposit: "Залог",
      extraKm: "Доп. км",
    },
    booking: {
      title: "Забронировать автомобиль",
      pickupDate: "Дата получения",
      returnDate: "Дата возврата",
      numberOfDays: "Количество дней",
      pickupLocation: "Место получения",
      returnLocation: "Место возврата",
      selectDatesOrDays: "Выберите даты или количество дней",
      estimatedTotal: "Предварительная стоимость",
      invalidDates: "Неверные даты",
      minimumRental: "Минимальная аренда: 1 день",
      days: "дней",
      day: "день",
      reserve: "Забронировать через WhatsApp",
      pickDate: "Выбрать дату",
      perDay: "/ день",
      perWeek: "/ неделя",
      perMonth: "/ месяц",
      locationPlaceholder: "Отель, аэропорт, адрес или город",
    },
    locations: ["Аэропорт Аликанте", "Бенидорм", "Альтеа", "Кальпе", "Морайра", "Хавеа", "Дения", "Аэропорт Валенсия"],
    conditions: {
      title: "Условия аренды",
      vehicleConditions: "Условия по автомобилю",
      globalConditions: "Общие условия",
      close: "Закрыть",
    },
    routes: {
      kicker: "Маршруты",
      title: "Премиальные автомобильные маршруты",
      subtitle: "Откройте Коста-Бланку через эксклюзивные маршруты.",
      explore: "Смотреть маршрут",
      recommendedCar: "Рекомендуемый автомобиль",
      stops: "Основные остановки",
      book: "Забронировать этот маршрут",
      backToRoutes: "Назад к маршрутам",
      gallery: "Галерея",
      seoText: "Для водителей, которые ищут больше, чем просто дорогу. Забронируйте автомобиль через WhatsApp.",
      whyPremium: "Почему этот маршрут идеален для премиального или спортивного автомобиля",
      bestTime: "Лучшее время дня",
      duration: "Примерная продолжительность",
    },
    guides: { title: "Гиды" },
    contact: {
      kicker: "Связаться",
      title: "Готовы к поездке?",
      subtitle: "Отправьте нам даты, и мы подтвердим доступность напрямую через WhatsApp.",
      cta: "Связаться через WhatsApp",
      hours: "Время работы",
      location: "Адрес",
      email: "Email",
      phone: "Телефон",
      reservations: "Бронирования (WhatsApp)",
    },
    footer: {
      tagline: "Премиальный опыт вождения на средиземноморском побережье.",
      rights: "Все права защищены.",
      legal: "Юридическая информация",
      brand: "Бренд",
      contactUs: "Контакт",
      guides: "Рекомендуемые авто",
      guidesLink: "Гиды",
    },
    legal: {
      kicker: "Правовая информация", pendingReview: "Ожидает юридической проверки",
      rental_conditions: "Условия аренды",
      terms: "Условия и положения",
      privacy: "Политика конфиденциальности",
      cookies: "Политика cookies",
    },
    whatsapp: {
      simple: (v) => `Здравствуйте, я хотел бы получить информацию об автомобиле: ${v}`,
      simpleDates: (v, p, r) =>
        `Здравствуйте, я хотел бы получить информацию об этом автомобиле:\n\nАвтомобиль: ${v}\nДата получения: ${p}\nДата возврата: ${r}\n\nСпасибо.`,
      withDates: (v, p, r) =>
        `Здравствуйте, я хотел бы получить информацию об этом автомобиле:\n\nАвтомобиль: ${v}\nДата получения: ${p}\nДата возврата: ${r}\n\nСпасибо.`,
      generic: "Здравствуйте, я хотел бы получить информацию о вашем автопарке премиум-класса.",
      routeInquiry: (route) => `Здравствуйте, меня интересует маршрут: ${route}. Можете порекомендовать автомобиль и подтвердить доступность?`,
    },
    admin: {
      login: "Вход админ",
      email: "Email",
      password: "Пароль",
      currentPassword: "Текущий пароль",
      newPassword: "Новый пароль",
      changePassword: "Сменить пароль",
      signin: "Войти",
      dashboard: "Панель",
      vehicles: "Автомобили",
      adminRoutes: "Маршруты",
      bookings: "Бронирования",
      settings: "Настройки",
      logout: "Выйти",
      add: "Добавить",
      edit: "Редактировать",
      delete: "Удалить",
      save: "Сохранить",
      cancel: "Отмена",
      confirm: "Уверены?",
      noData: "Данных пока нет.",
      uploadImage: "Загрузить фото",
      uploadVideo: "Загрузить видео",
      uploadFile: "Загрузить файл",
      dropHere: "Перетащите или нажмите",
      mainPhoto: "Главное",
      makeMain: "Сделать главным",
      moveUp: "Выше",
      moveDown: "Ниже",
      missingData: "Не хватает данных",
    },
    months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    weekdays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
    dateFormat: "dd.MM.yyyy",
  },
};

export default T;

// --- Native structural locales --------------------------------------------
T.fr = {
  nav:{home:"Accueil",catalog:"Catalogue",routes:"Itinéraires",contact:"Contact",admin:"Administration"},
  hero:{title:"Voitures de sport et de luxe.",subtitle:"Expériences premium de location automobile sur la Costa Blanca.",cta:"Découvrir la collection"},
  catalog:{kicker:"La collection",title:"Choisissez votre expérience",subtitle:"Des voitures de luxe et de sport prêtes pour votre prochain trajet.",filterAll:"Toutes",viewImages:"Voir les photos",conditions:"Conditions",moreInfo:"Plus d’informations",reserve:"Réserver sur WhatsApp",contactWa24h:"Contacter par WhatsApp 24 h/24",selectDates:"Sélectionnez les dates de prise en charge et de retour",pricePerDay:"par jour",from:"À partir de",available:"Disponible",notAvailable:"Indisponible",empty:"Aucun véhicule dans cette catégorie pour le moment.",perMonth:"/ mois",priceOnRequest:"Prix sur demande",hp:"ch",topSpeed:"Vitesse max.",acceleration:"0-100",seats:"places",location:"Lieu"},
  vehicleDetail:{notFound:"Ce véhicule n’est pas disponible actuellement.",backToCatalog:"Retour à la collection",reserveWithDates:"Réserver avec des dates",contactDirect:"Contact direct",faqTitle:"Questions fréquentes",deposit:"Caution",extraKm:"Km supplémentaire"},
  booking:{title:"Réserver cette voiture",pickupDate:"Date de prise en charge",returnDate:"Date de retour",numberOfDays:"Nombre de jours",pickupLocation:"Lieu de prise en charge",returnLocation:"Lieu de retour",selectDatesOrDays:"Sélectionnez les dates ou le nombre de jours",estimatedTotal:"Total estimé",invalidDates:"Dates invalides",minimumRental:"Location minimum : 1 jour",days:"jours",day:"jour",reserve:"Réserver sur WhatsApp",pickDate:"Choisir une date",perDay:"/ jour",perWeek:"/ semaine",perMonth:"/ mois",locationPlaceholder:"Hôtel, aéroport, adresse ou ville"},
  locations:["Aéroport d’Alicante","Benidorm","Altea","Calpe","Moraira","Jávea","Dénia","Aéroport de Valence"],
  conditions:{title:"Conditions de location",vehicleConditions:"Conditions du véhicule",globalConditions:"Conditions générales",close:"Fermer"},
  routes:{kicker:"Itinéraires",title:"Itinéraires de conduite premium",subtitle:"Découvrez la Costa Blanca grâce à nos itinéraires sélectionnés.",explore:"Découvrir l’itinéraire",recommendedCar:"Voiture recommandée",stops:"Étapes principales",book:"Réserver cet itinéraire",backToRoutes:"Retour aux itinéraires",gallery:"Galerie",seoText:"Pensé pour les conducteurs qui recherchent plus qu’une route. Réservez votre voiture sur WhatsApp et nous préparerons l’expérience.",whyPremium:"Pourquoi cet itinéraire convient parfaitement à une voiture de luxe ou de sport",bestTime:"Meilleur moment de la journée",duration:"Durée approximative"},
  guides:{title:"Guides"},
  contact:{kicker:"Contactez-nous",title:"Prêt à prendre la route ?",subtitle:"Envoyez-nous vos dates et nous confirmerons directement la disponibilité sur WhatsApp.",cta:"Contacter par WhatsApp",hours:"Horaires d’ouverture",location:"Adresse",email:"E-mail",phone:"Téléphone",reservations:"Réservations (WhatsApp)"},
  footer:{tagline:"Expériences de conduite premium sur la côte méditerranéenne.",rights:"Tous droits réservés.",legal:"Mentions légales",brand:"Marque",contactUs:"Contact",guides:"Voitures à la une",guidesLink:"Guides"},
  legal:{kicker:"Mentions légales",pendingReview:"En attente de validation juridique",rental_conditions:"Conditions de location",terms:"Conditions générales",privacy:"Politique de confidentialité",cookies:"Politique relative aux cookies"},
  whatsapp:{simple:(v)=>"Bonjour, je souhaite obtenir des informations sur ce véhicule : "+v,simpleDates:(v,p,r)=>"Bonjour, je souhaite obtenir des informations sur ce véhicule :\n\nVéhicule : "+v+"\nDate de prise en charge : "+p+"\nDate de retour : "+r+"\n\nMerci.",withDates:(v,p,r)=>"Bonjour, je souhaite obtenir des informations sur ce véhicule :\n\nVéhicule : "+v+"\nDate de prise en charge : "+p+"\nDate de retour : "+r+"\n\nMerci.",generic:"Bonjour, je souhaite obtenir des informations sur votre flotte de location de luxe.",routeInquiry:(route)=>"Bonjour, l’itinéraire suivant m’intéresse : "+route+". Pouvez-vous recommander une voiture et confirmer sa disponibilité ?"},
  months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],weekdays:["Lun","Mar","Mer","Jeu","Ven","Sam","Dim"],dateFormat:"dd/MM/yyyy"
};
T.de = {
  nav:{home:"Startseite",catalog:"Fahrzeuge",routes:"Routen",contact:"Kontakt",admin:"Administration"},
  hero:{title:"Sport- und Luxuswagen.",subtitle:"Premium-Mietwagenerlebnisse an der Costa Blanca.",cta:"Kollektion entdecken"},
  catalog:{kicker:"Die Kollektion",title:"Wählen Sie Ihr Fahrerlebnis",subtitle:"Luxus- und Sportwagen für Ihre nächste Fahrt.",filterAll:"Alle",viewImages:"Bilder ansehen",conditions:"Bedingungen",moreInfo:"Mehr erfahren",reserve:"Über WhatsApp reservieren",contactWa24h:"24/7 über WhatsApp kontaktieren",selectDates:"Abhol- und Rückgabedatum auswählen",pricePerDay:"pro Tag",from:"Ab",available:"Verfügbar",notAvailable:"Nicht verfügbar",empty:"In dieser Kategorie sind derzeit keine Fahrzeuge verfügbar.",perMonth:"/ Monat",priceOnRequest:"Preis auf Anfrage",hp:"PS",topSpeed:"Höchstgeschw.",acceleration:"0-100",seats:"Sitze",location:"Standort"},
  vehicleDetail:{notFound:"Dieses Fahrzeug ist derzeit nicht verfügbar.",backToCatalog:"Zurück zur Kollektion",reserveWithDates:"Mit Daten reservieren",contactDirect:"Direkter Kontakt",faqTitle:"Häufig gestellte Fragen",deposit:"Kaution",extraKm:"Zusatzkilometer"},
  booking:{title:"Dieses Fahrzeug reservieren",pickupDate:"Abholdatum",returnDate:"Rückgabedatum",numberOfDays:"Anzahl der Tage",pickupLocation:"Abholort",returnLocation:"Rückgabeort",selectDatesOrDays:"Daten oder Anzahl der Tage auswählen",estimatedTotal:"Geschätzter Gesamtpreis",invalidDates:"Ungültige Daten",minimumRental:"Mindestmiete: 1 Tag",days:"Tage",day:"Tag",reserve:"Über WhatsApp reservieren",pickDate:"Datum auswählen",perDay:"/ Tag",perWeek:"/ Woche",perMonth:"/ Monat",locationPlaceholder:"Hotel, Flughafen, Adresse oder Stadt"},
  locations:["Flughafen Alicante","Benidorm","Altea","Calpe","Moraira","Jávea","Dénia","Flughafen Valencia"],
  conditions:{title:"Mietbedingungen",vehicleConditions:"Fahrzeugbedingungen",globalConditions:"Allgemeine Bedingungen",close:"Schließen"},
  routes:{kicker:"Fahrstrecken",title:"Premium-Fahrstrecken",subtitle:"Entdecken Sie die Costa Blanca auf sorgfältig ausgewählten Routen.",explore:"Route entdecken",recommendedCar:"Empfohlenes Fahrzeug",stops:"Wichtigste Stopps",book:"Diese Route buchen",backToRoutes:"Zurück zu den Routen",gallery:"Galerie",seoText:"Für Fahrer, die mehr als nur eine Straße suchen. Reservieren Sie Ihr Fahrzeug per WhatsApp und wir bereiten das Erlebnis vor.",whyPremium:"Warum diese Route ideal für einen Luxus- oder Sportwagen ist",bestTime:"Beste Tageszeit",duration:"Ungefähre Dauer"},
  guides:{title:"Ratgeber"},
  contact:{kicker:"Kontakt aufnehmen",title:"Bereit für die Fahrt?",subtitle:"Senden Sie uns Ihre Daten; wir bestätigen die Verfügbarkeit direkt über WhatsApp.",cta:"Über WhatsApp kontaktieren",hours:"Öffnungszeiten",location:"Adresse",email:"E-Mail",phone:"Telefon",reservations:"Reservierungen (WhatsApp)"},
  footer:{tagline:"Premium-Fahrerlebnisse an der Mittelmeerküste.",rights:"Alle Rechte vorbehalten.",legal:"Rechtliches",brand:"Marke",contactUs:"Kontakt",guides:"Ausgewählte Fahrzeuge",guidesLink:"Ratgeber"},
  legal:{kicker:"Rechtliches",pendingReview:"Rechtliche Prüfung ausstehend",rental_conditions:"Mietbedingungen",terms:"Allgemeine Geschäftsbedingungen",privacy:"Datenschutzerklärung",cookies:"Cookie-Richtlinie"},
  whatsapp:{simple:(v)=>"Hallo, ich möchte Informationen zu diesem Fahrzeug: "+v,simpleDates:(v,p,r)=>"Hallo, ich möchte Informationen zu diesem Fahrzeug:\n\nFahrzeug: "+v+"\nAbholdatum: "+p+"\nRückgabedatum: "+r+"\n\nVielen Dank.",withDates:(v,p,r)=>"Hallo, ich möchte Informationen zu diesem Fahrzeug:\n\nFahrzeug: "+v+"\nAbholdatum: "+p+"\nRückgabedatum: "+r+"\n\nVielen Dank.",generic:"Hallo, ich möchte Informationen zu Ihrer Luxusmietwagenflotte.",routeInquiry:(route)=>"Hallo, ich interessiere mich für die Route "+route+". Können Sie ein Fahrzeug empfehlen und die Verfügbarkeit bestätigen?"},
  months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],weekdays:["Mo","Di","Mi","Do","Fr","Sa","So"],dateFormat:"dd.MM.yyyy"
};
T.it = {
  nav:{home:"Home",catalog:"Catalogo",routes:"Itinerari",contact:"Contatti",admin:"Amministrazione"},
  hero:{title:"Auto sportive e di lusso.",subtitle:"Esperienze premium di noleggio auto sulla Costa Blanca.",cta:"Scopri la collezione"},
  catalog:{kicker:"La collezione",title:"Scegli la tua esperienza",subtitle:"Auto di lusso e sportive pronte per il tuo prossimo viaggio.",filterAll:"Tutte",viewImages:"Vedi immagini",conditions:"Condizioni",moreInfo:"Maggiori informazioni",reserve:"Prenota su WhatsApp",contactWa24h:"Contattaci su WhatsApp 24 ore su 24",selectDates:"Seleziona le date di ritiro e riconsegna",pricePerDay:"al giorno",from:"Da",available:"Disponibile",notAvailable:"Non disponibile",empty:"Nessun veicolo disponibile in questa categoria.",perMonth:"/ mese",priceOnRequest:"Prezzo su richiesta",hp:"CV",topSpeed:"Velocità max",acceleration:"0-100",seats:"posti",location:"Località"},
  vehicleDetail:{notFound:"Questo veicolo non è disponibile al momento.",backToCatalog:"Torna alla collezione",reserveWithDates:"Prenota con le date",contactDirect:"Contatto diretto",faqTitle:"Domande frequenti",deposit:"Deposito",extraKm:"Km extra"},
  booking:{title:"Prenota questa auto",pickupDate:"Data di ritiro",returnDate:"Data di riconsegna",numberOfDays:"Numero di giorni",pickupLocation:"Luogo di ritiro",returnLocation:"Luogo di riconsegna",selectDatesOrDays:"Seleziona le date o il numero di giorni",estimatedTotal:"Totale stimato",invalidDates:"Date non valide",minimumRental:"Noleggio minimo: 1 giorno",days:"giorni",day:"giorno",reserve:"Prenota su WhatsApp",pickDate:"Scegli una data",perDay:"/ giorno",perWeek:"/ settimana",perMonth:"/ mese",locationPlaceholder:"Hotel, aeroporto, indirizzo o città"},
  locations:["Aeroporto di Alicante","Benidorm","Altea","Calpe","Moraira","Jávea","Dénia","Aeroporto di Valencia"],
  conditions:{title:"Condizioni di noleggio",vehicleConditions:"Condizioni del veicolo",globalConditions:"Condizioni generali",close:"Chiudi"},
  routes:{kicker:"Itinerari di guida",title:"Itinerari di guida premium",subtitle:"Scopri la Costa Blanca attraverso itinerari selezionati.",explore:"Scopri l’itinerario",recommendedCar:"Auto consigliata",stops:"Tappe principali",book:"Prenota questo itinerario",backToRoutes:"Torna agli itinerari",gallery:"Galleria",seoText:"Per chi cerca più di una semplice strada. Prenota l’auto su WhatsApp e prepareremo l’esperienza.",whyPremium:"Perché questo itinerario è perfetto per un’auto di lusso o sportiva",bestTime:"Momento migliore della giornata",duration:"Durata approssimativa"},
  guides:{title:"Guide"},
  contact:{kicker:"Contattaci",title:"Pronto a partire?",subtitle:"Inviaci le date e confermeremo la disponibilità direttamente su WhatsApp.",cta:"Contatta su WhatsApp",hours:"Orari di apertura",location:"Indirizzo",email:"E-mail",phone:"Telefono",reservations:"Prenotazioni (WhatsApp)"},
  footer:{tagline:"Esperienze di guida premium sulla costa mediterranea.",rights:"Tutti i diritti riservati.",legal:"Note legali",brand:"Marchio",contactUs:"Contatti",guides:"Auto in evidenza",guidesLink:"Guide"},
  legal:{kicker:"Note legali",pendingReview:"In attesa di revisione legale",rental_conditions:"Condizioni di noleggio",terms:"Termini e condizioni",privacy:"Informativa sulla privacy",cookies:"Informativa sui cookie"},
  whatsapp:{simple:(v)=>"Salve, vorrei informazioni su questo veicolo: "+v,simpleDates:(v,p,r)=>"Salve, vorrei informazioni su questo veicolo:\n\nVeicolo: "+v+"\nData di ritiro: "+p+"\nData di riconsegna: "+r+"\n\nGrazie.",withDates:(v,p,r)=>"Salve, vorrei informazioni su questo veicolo:\n\nVeicolo: "+v+"\nData di ritiro: "+p+"\nData di riconsegna: "+r+"\n\nGrazie.",generic:"Salve, vorrei informazioni sulla vostra flotta di auto di lusso.",routeInquiry:(route)=>"Salve, mi interessa l’itinerario "+route+". Potete consigliare un’auto e confermare la disponibilità?"},
  months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],weekdays:["Lun","Mar","Mer","Gio","Ven","Sab","Dom"],dateFormat:"dd/MM/yyyy"
};
T.nl = {
  nav:{home:"Home",catalog:"Auto’s",routes:"Routes",contact:"Contact",admin:"Beheer"},
  hero:{title:"Sport- en luxeauto’s.",subtitle:"Premium autoverhuurervaringen aan de Costa Blanca.",cta:"Bekijk de collectie"},
  catalog:{kicker:"De collectie",title:"Kies uw rijervaring",subtitle:"Luxe- en sportauto’s voor uw volgende rit.",filterAll:"Alle",viewImages:"Foto’s bekijken",conditions:"Voorwaarden",moreInfo:"Meer informatie",reserve:"Reserveren via WhatsApp",contactWa24h:"24/7 contact via WhatsApp",selectDates:"Kies de ophaal- en inleverdatum",pricePerDay:"per dag",from:"Vanaf",available:"Beschikbaar",notAvailable:"Niet beschikbaar",empty:"Momenteel zijn er geen voertuigen in deze categorie.",perMonth:"/ maand",priceOnRequest:"Prijs op aanvraag",hp:"pk",topSpeed:"Topsnelheid",acceleration:"0-100",seats:"zitplaatsen",location:"Locatie"},
  vehicleDetail:{notFound:"Dit voertuig is momenteel niet beschikbaar.",backToCatalog:"Terug naar de collectie",reserveWithDates:"Reserveren met data",contactDirect:"Direct contact",faqTitle:"Veelgestelde vragen",deposit:"Borg",extraKm:"Extra km"},
  booking:{title:"Deze auto reserveren",pickupDate:"Ophaaldatum",returnDate:"Inleverdatum",numberOfDays:"Aantal dagen",pickupLocation:"Ophaallocatie",returnLocation:"Inleverlocatie",selectDatesOrDays:"Kies data of het aantal dagen",estimatedTotal:"Geschat totaal",invalidDates:"Ongeldige data",minimumRental:"Minimale huur: 1 dag",days:"dagen",day:"dag",reserve:"Reserveren via WhatsApp",pickDate:"Kies een datum",perDay:"/ dag",perWeek:"/ week",perMonth:"/ maand",locationPlaceholder:"Hotel, luchthaven, adres of plaats"},
  locations:["Luchthaven Alicante","Benidorm","Altea","Calpe","Moraira","Jávea","Dénia","Luchthaven Valencia"],
  conditions:{title:"Huurvoorwaarden",vehicleConditions:"Voertuigvoorwaarden",globalConditions:"Algemene voorwaarden",close:"Sluiten"},
  routes:{kicker:"Autoroutes",title:"Premium autoroutes",subtitle:"Ontdek de Costa Blanca via zorgvuldig samengestelde routes.",explore:"Route bekijken",recommendedCar:"Aanbevolen auto",stops:"Belangrijkste stops",book:"Deze route boeken",backToRoutes:"Terug naar routes",gallery:"Galerij",seoText:"Voor bestuurders die meer zoeken dan alleen een weg. Reserveer uw auto via WhatsApp en wij bereiden de ervaring voor.",whyPremium:"Waarom deze route ideaal is voor een luxe- of sportauto",bestTime:"Beste moment van de dag",duration:"Geschatte duur"},
  guides:{title:"Gidsen"},
  contact:{kicker:"Neem contact op",title:"Klaar om te rijden?",subtitle:"Stuur ons uw data; wij bevestigen de beschikbaarheid direct via WhatsApp.",cta:"Contact via WhatsApp",hours:"Openingstijden",location:"Adres",email:"E-mail",phone:"Telefoon",reservations:"Reserveringen (WhatsApp)"},
  footer:{tagline:"Premium rijervaringen aan de Middellandse Zeekust.",rights:"Alle rechten voorbehouden.",legal:"Juridisch",brand:"Merk",contactUs:"Contact",guides:"Uitgelichte auto’s",guidesLink:"Gidsen"},
  legal:{kicker:"Juridisch",pendingReview:"Juridische controle in behandeling",rental_conditions:"Huurvoorwaarden",terms:"Algemene voorwaarden",privacy:"Privacybeleid",cookies:"Cookiebeleid"},
  whatsapp:{simple:(v)=>"Hallo, ik ontvang graag informatie over dit voertuig: "+v,simpleDates:(v,p,r)=>"Hallo, ik ontvang graag informatie over dit voertuig:\n\nVoertuig: "+v+"\nOphaaldatum: "+p+"\nInleverdatum: "+r+"\n\nBedankt.",withDates:(v,p,r)=>"Hallo, ik ontvang graag informatie over dit voertuig:\n\nVoertuig: "+v+"\nOphaaldatum: "+p+"\nInleverdatum: "+r+"\n\nBedankt.",generic:"Hallo, ik ontvang graag informatie over uw luxe huurvloot.",routeInquiry:(route)=>"Hallo, ik ben geïnteresseerd in de route "+route+". Kunt u een auto aanbevelen en de beschikbaarheid bevestigen?"},
  months:["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"],weekdays:["Ma","Di","Wo","Do","Vr","Za","Zo"],dateFormat:"dd-MM-yyyy"
};
T.pl = {
  nav:{home:"Strona główna",catalog:"Samochody",routes:"Trasy",contact:"Kontakt",admin:"Administracja"},
  hero:{title:"Samochody sportowe i luksusowe.",subtitle:"Ekskluzywny wynajem samochodów na Costa Blanca.",cta:"Poznaj kolekcję"},
  catalog:{kicker:"Kolekcja",title:"Wybierz swoje doświadczenie",subtitle:"Luksusowe i sportowe samochody gotowe na kolejną podróż.",filterAll:"Wszystkie",viewImages:"Zobacz zdjęcia",conditions:"Warunki",moreInfo:"Więcej informacji",reserve:"Zarezerwuj przez WhatsApp",contactWa24h:"Kontakt przez WhatsApp 24/7",selectDates:"Wybierz daty odbioru i zwrotu",pricePerDay:"za dzień",from:"Od",available:"Dostępny",notAvailable:"Niedostępny",empty:"Obecnie brak pojazdów w tej kategorii.",perMonth:"/ miesiąc",priceOnRequest:"Cena na zapytanie",hp:"KM",topSpeed:"Prędkość maks.",acceleration:"0-100",seats:"miejsca",location:"Lokalizacja"},
  vehicleDetail:{notFound:"Ten pojazd nie jest obecnie dostępny.",backToCatalog:"Wróć do kolekcji",reserveWithDates:"Rezerwuj z datami",contactDirect:"Kontakt bezpośredni",faqTitle:"Najczęściej zadawane pytania",deposit:"Kaucja",extraKm:"Dodatkowy km"},
  booking:{title:"Zarezerwuj ten samochód",pickupDate:"Data odbioru",returnDate:"Data zwrotu",numberOfDays:"Liczba dni",pickupLocation:"Miejsce odbioru",returnLocation:"Miejsce zwrotu",selectDatesOrDays:"Wybierz daty lub liczbę dni",estimatedTotal:"Szacowana suma",invalidDates:"Nieprawidłowe daty",minimumRental:"Minimalny wynajem: 1 dzień",days:"dni",day:"dzień",reserve:"Zarezerwuj przez WhatsApp",pickDate:"Wybierz datę",perDay:"/ dzień",perWeek:"/ tydzień",perMonth:"/ miesiąc",locationPlaceholder:"Hotel, lotnisko, adres lub miasto"},
  locations:["Lotnisko Alicante","Benidorm","Altea","Calpe","Moraira","Jávea","Dénia","Lotnisko Walencja"],
  conditions:{title:"Warunki wynajmu",vehicleConditions:"Warunki pojazdu",globalConditions:"Warunki ogólne",close:"Zamknij"},
  routes:{kicker:"Trasy samochodowe",title:"Ekskluzywne trasy samochodowe",subtitle:"Odkrywaj Costa Blanca na starannie wybranych trasach.",explore:"Poznaj trasę",recommendedCar:"Polecany samochód",stops:"Główne przystanki",book:"Zarezerwuj tę trasę",backToRoutes:"Wróć do tras",gallery:"Galeria",seoText:"Dla kierowców, którzy oczekują więcej niż samej drogi. Zarezerwuj samochód przez WhatsApp, a przygotujemy całe doświadczenie.",whyPremium:"Dlaczego ta trasa jest idealna dla samochodu luksusowego lub sportowego",bestTime:"Najlepsza pora dnia",duration:"Przybliżony czas"},
  guides:{title:"Poradniki"},
  contact:{kicker:"Skontaktuj się",title:"Gotowy do jazdy?",subtitle:"Wyślij nam daty, a potwierdzimy dostępność bezpośrednio przez WhatsApp.",cta:"Kontakt przez WhatsApp",hours:"Godziny otwarcia",location:"Adres",email:"E-mail",phone:"Telefon",reservations:"Rezerwacje (WhatsApp)"},
  footer:{tagline:"Ekskluzywne doświadczenia za kierownicą na wybrzeżu Morza Śródziemnego.",rights:"Wszelkie prawa zastrzeżone.",legal:"Informacje prawne",brand:"Marka",contactUs:"Kontakt",guides:"Polecane samochody",guidesLink:"Poradniki"},
  legal:{kicker:"Informacje prawne",pendingReview:"Oczekuje na weryfikację prawną",rental_conditions:"Warunki wynajmu",terms:"Regulamin",privacy:"Polityka prywatności",cookies:"Polityka cookies"},
  whatsapp:{simple:(v)=>"Dzień dobry, proszę o informacje o tym pojeździe: "+v,simpleDates:(v,p,r)=>"Dzień dobry, proszę o informacje o tym pojeździe:\n\nPojazd: "+v+"\nData odbioru: "+p+"\nData zwrotu: "+r+"\n\nDziękuję.",withDates:(v,p,r)=>"Dzień dobry, proszę o informacje o tym pojeździe:\n\nPojazd: "+v+"\nData odbioru: "+p+"\nData zwrotu: "+r+"\n\nDziękuję.",generic:"Dzień dobry, proszę o informacje o Państwa flocie luksusowych samochodów.",routeInquiry:(route)=>"Dzień dobry, interesuje mnie trasa "+route+". Czy mogą Państwo polecić samochód i potwierdzić dostępność?"},
  months:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],weekdays:["Pon","Wt","Śr","Czw","Pt","Sob","Nd"],dateFormat:"dd.MM.yyyy"
};
